<template>
  <v-row justify="center">
    <v-dialog
      :value="active"
      max-width="500"
      @click:outside="$emit('dialog:change', 'cerrar')"
    >
      <ValidationObserver ref="obs" v-slot="{ passes }">
        <v-card :loading="loading">
          <v-card-title class="pa-0 shadow-1">
            <v-card-title class="font-weight-medium primary--text">
              {{
                value === 0
                  ? `Registrar hijo a: (${data.typification_name})`
                  : "Actualizar Tipificación"
              }}
            </v-card-title>
          </v-card-title>
          <v-card-text class="py-2">
            <v-form>
              <ValidationProvider name="nombre" rules="required" v-slot="{ errors }">
                <v-text-field
                  :error-messages="errors"
                  class="px-2 pt-3"
                  label="Nombre"
                  name="nombre"
                  prepend-inner-icon="mdi-account"
                  autofocus
                  v-model="data.name"
                  required
                  filled
                  rounded
                  dense
                  clearable
                >
                </v-text-field>
              </ValidationProvider>
            </v-form>
          </v-card-text>

          <v-card-actions>
            <v-spacer></v-spacer>

            <v-hover v-slot:default="{ hover }">
              <v-btn
                rounded
                color="success"
                :class="hover ? 'shadow-2' : 'shadow-4'"
                class="px-5"
                @click="
                  () => {
                    value === 0 ? passes(register) : passes(update);
                  }
                "
              >
                {{ value === 0 ? "Registrar" : "Actualizar" }}
              </v-btn>
            </v-hover>

            <v-hover v-slot:default="{ hover }">
              <v-btn
                text
                rounded
                class="mr-1"
                :color="hover ? 'error' : 'grey'"
                @click="$emit('dialog:change', 'cerrar')"
              >
                Cancelar
              </v-btn>
            </v-hover>
          </v-card-actions>
        </v-card>
      </ValidationObserver>
    </v-dialog>
  </v-row>
</template>

<script>
export default {
  props: ["active", "data", "value", "deepChild", "parent_id"],
  data() {
    return {
      search: "",
      dialog: false,
      loading: false,
      cola: [],
    };
  },

  created() {
    // this.getColas();
  },

  watch: {
    active(val) {
      if (!val) this.resetform();
    },
  },

  methods: {
    resetform() {
      this.$refs.obs.reset();
    },

    // async getColas() {
    //   try {
    //     const response = await this.$store.dispatch("queue/SHOW_QUEUE");
    //     this.cola = response.data.data;
    //   } catch (error) {
    //     console.log(error);
    //   }
    // },

    async register() {
      try {
        this.loading = true;
        const enviar = {
          name: this.data.name,
          typification_id: this.deepChild ? undefined : this.data.typification_id,
          queue_id: this.data.queue_id,
          parent_id: this.deepChild ? this.parent_id : undefined,
        };
        const response = await this.$store.dispatch(
          "typifications/REGISTER_TYPIFICATIONS",
          enviar
        );
        this.loading = false;
        this.resetform();
        let message = response.data.message;
        this.$emit("dialog:change", message);
      } catch (error) {
        this.$snotify.error(error, "Error");
      }
    },
    async update() {
      try {
        this.loading = true;
        const enviar = {
          data: {
            name: this.data.name,
            number: parseInt(this.data.number),
          },
          id: this.data.id,
        };
        const response = await this.$store.dispatch("queue/EDIT_QUEUE", enviar);
        this.loading = false;
        this.resetform();
        let message = response.data.message;
        this.$emit("dialog:change", message);
      } catch (error) {
        console.log(error);
      }
    },
    eventdialog() {
      this.activeAlert = false;
    },
  },
};
</script>
